import * as React from 'react';
import styles from './select-expander.scss';
import { Triangle } from 'ui';

export interface SelectExpanderProps {
  id?: string;
  className?: string;
}

export const SelectExpander: React.SFC<SelectExpanderProps> = ({id, className,  children}) => {
  return (
    <div className={`${styles.selectExpander} select-expander scale-animate`}>
      <Triangle/>
      <div id={id} className={`${styles.collapseContainer} ${className} collapse show container dialog-expander`}>
        <div className={styles.expander}>
          {children}
        </div>
      </div>
    </div>
  );
};
